// COMPLIANCE APPROVED TERMS
export const CREDIT_ACCOUNT_SECTION_NAME = 'credit';
export const SPENDING_ACCOUNT_SECTION_NAME = 'spending'; // "spending" account here means a "checking/debit" account; not to be confused with the Chime Card "spending account" type

export const saferCreditTitleText = 'Safer Credit Building (optional)';

export const chimePrivacyNoticeText = 'Chime U.S. Privacy Notice';
export const privacyNoticeText = 'Consumer Privacy Notice';
export const chimeUserAgreementText = 'Chime User Agreement';
export const electronicCommunicationsText =
  'Electronic Communication Agreement';
export const chimeCreditBuilderCardName =
  'Chime Credit Builder Secured Visa® Credit Card';

// CHIME CARD
export const chimeCardDepositAgreementText = 'Chime Deposit Account Agreement';
export const chimeCardName = 'secured Chime Visa® Credit Card';
export const chimeCardAgreementText =
  'Secured Chime Visa Credit Card Agreement';
export const chimeCardProgramAddendumText =
  'Secured Chime Visa Credit Card - Cash Rewards Program Addendum';
export const chimeCardApplicationDisclosureText =
  'Application Disclosure and Secured Deposit Account Agreement';

// STRIDE
export const strideOfficialBankName = 'Stride Bank, N.A.';
export const stridePrivacyNoticeText = 'The Stride Consumer Privacy Notice';
export const strideDepositAgreementText = 'Chime Deposit Account Agreement';
export const strideApplicationDisclosureText =
  'Application Disclosure and Secured Account Agreement';
export const strideElectronicCommsText =
  'Chime Electronic Communication Agreement';
export const strideCreditCardAgreementText = 'Chime Credit Card Agreement';
export const strideApplicationDisclosureLink =
  'https://www.chime.com/chime-credit-builder-application-disclosure-and-secured-account-agreement/';
export const strideCreditCardAgreementLink =
  'https://www.chime.com/chime-credit-builder-visa-credit-card-agreement/';

// BANCORP
export const bancorpOfficialBankName = 'The Bancorp Bank, N.A.';
export const bancorpPrivacyNoticeText =
  'The Bancorp Bank, N.A. Consumer Privacy Notice';
export const bancorpApplicationDisclosureText =
  'Application Disclosure and Secured Deposit Account Agreement';
export const bancorpDepositAgreementText = 'Deposit Account Agreement';
export const bancorpCreditCardAgreementText = 'Chime Credit Card Agreement';

// SAFER CREDIT
export const saferCreditDesc =
  'Each month, on the day after you receive your statement, we will use the money you added to Credit Builder to automatically cover your charges.';
export const learnMoreSaferCreditLink =
  'https://www.chime.com/policies/safer-credit-building/';

// ECBSV
export const eCBSVTitleText =
  'Authorization for the Social Security Administration to Disclose Your Social Security Number Verification';
export const eCBSVAgreementTextBancorp =
  'I authorize the Social Security Administration (SSA) to verify and disclose to The Bancorp Bank, N.A., through Socure, Inc., their service provider for the purpose of this verification, whether the name, Social Security Number (SSN) and date of birth I have submitted matches information in the SSA records. My consent is for a one time validation within the next 90 days.';
export const eCBSVAgreementTextStride =
  'I authorize the Social Security Administration (SSA) to verify and disclose to Stride Bank, N.A., through Socure, Inc., their service provider for the purpose of this verification, whether the name, Social Security Number (SSN) and date of birth I have submitted matches information in the SSA records. My consent is for a one time validation within the next 90 days.';
export const eCBSVAgreementParagraphTwo =
  'By clicking the checkbox above, I agree and consent for the SSA to disclose my SSN Verification to Socure. I agree that my electronic signature has the same legal meaning, validity, and effect as my handwritten signature.';

// ECBSV Mandatory Consent Experiment
export const mandatoryECBSVAgreementParagraphOneBancorpExperiment =
  'I authorize the Social Security Administration (SSA) to verify and disclose to The Bancorp Bank, N.A., through Socure, Inc., their service provider for the purpose of this verification, whether the name, Social Security Number (SSN) and date of birth I have submitted matches information in the SSA records. My consent is for a one-time validation within the next 90 days.';
export const mandatoryECBSVAgreementParagraphOneStrideExperiment =
  'I authorize the Social Security Administration (SSA) to verify and disclose to Stride Bank, N.A., through Socure, Inc., their service provider for the purpose of this verification, whether the name, Social Security Number (SSN) and date of birth I have submitted matches information in the SSA records. My consent is for a one-time validation within the next 90 days.';
export const mandatoryECBSVAgreementParagraphTwoBancorpExperiment =
  'By clicking "Agree", I agree and consent for the SSA to disclose my SSN Verification to The Bancorp Bank, N.A. and Socure. I agree that my electronic signature has the same legal meaning, validity, and effect as my handwritten signature.';
export const mandatoryECBSVAgreementParagraphTwoStrideExperiment =
  'By clicking "Agree", I agree and consent for the SSA to disclose my SSN Verification to Stride Bank, N.A. and Socure. I agree that my electronic signature has the same legal meaning, validity, and effect as my handwritten signature.';
export const mandatoryECBSVAgreementParagraphTwoBancorpConfirmExperiment =
  'By clicking "Confirm", I agree and consent for the SSA to disclose my SSN Verification to The Bancorp Bank, N.A. and Socure. I agree that my electronic signature has the same legal meaning, validity, and effect as my handwritten signature.';
export const mandatoryECBSVAgreementParagraphTwoStrideConfirmExperiment =
  'By clicking "Confirm", I agree and consent for the SSA to disclose my SSN Verification to Stride Bank, N.A. and Socure. I agree that my electronic signature has the same legal meaning, validity, and effect as my handwritten signature.';

// SMS Agreement
export const smsAgreementText = 'Telephone Use Agreement';
